


















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DateInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import DateObject from "../../../document/editor/objects/DateObject.vue";
import DateInputMethodSelector from "../inputMethodEditors/DateInputMethodSelector.vue";
import { CommonComponentsAccessibleMixin } from "../mixins";
import ClipboardMenu from "./ClipboardMenu.vue";
import ObjectMenuButton from "./ObjectMenuButton.vue";
import FixedDateMenu from "./FixedDateMenu.vue";

@Component({
  components: {
    ClipboardMenu,
    DateInputMethodSelector,
    ObjectMenuButton,
    FixedDateMenu,
  }
})
export default class DateObjectMenu extends Mixins(CommonComponentsAccessibleMixin) {
  @Prop()
  source: DateObject;

  @Prop()
  isInputMethodSelectable: boolean;

  get selected(): DateInputMethodKinds {
    return this.source.inputMethodKind;
  }

  set selected(value: DateInputMethodKinds) {
    this.source.inputMethodKind = value;
    this.source.emitFocus();
  }

  get indeterminationDateName(): string {
    return "不詳";
  }
  
  get unknownDateName(): string {
    return "不明";
  }

  get isFixedDateInputable(): boolean {
    return this.source.isCalendarInputtable && this.source.isApproximateInputable;
  }

  getButtonClass(kind: DateInputMethodKinds): string {
    return Enumerable.from(this.buttonClasses)
      .first(c => c.key === kind)
      .toClass(this.source);
  }

  isVisible(kind: DateInputMethodKinds): boolean {
    return !!this.getButtonClass(kind);
  }

  buttonClasses: { key: DateInputMethodKinds, toClass: (source: DateObject) => string }[] = [
    { key: DateInputMethodKinds.None, toClass: s => "date-object-menu-none" },
    { key: DateInputMethodKinds.FreeInput, toClass: s => "date-object-menu-free" },
    { key: DateInputMethodKinds.Calendar, toClass: s => s.editingSource.value.isTime ? "date-object-menu-time" : "date-object-menu-date" },
    { key: DateInputMethodKinds.Calculate, toClass: s => "date-object-menu-calculate" },
    { key: DateInputMethodKinds.HisInfoSelect, toClass: s => "date-object-menu-data" },
    { key: DateInputMethodKinds.UserDefinitionSelect, toClass: s => "date-object-menu-data" },
  ];
}
